export default __webpack_public_path__ + "static/media/mobilityIcon.68214063.svg";